import {invalidateQueries, q} from "../state";
import {
  AccountFeature,
  AiModelConfig,
  ProcessStepPropertyConfig,
  PromptModifiers,
  QAMode,
  TprmAccountPreferences,
} from "platformed-client/types";
import {platformedClient} from ".";

export async function changeName(name: string) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/account_name`, {
    path: {},
    body: name,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateLanguageCode(languageCode: string) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/language_code`, {
    path: {},
    body: languageCode,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updatePlanFeature(feature: AccountFeature, active: boolean) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/plan_features/{feature}`, {
    path: {feature},
    body: active,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateEnabledFeature(feature: AccountFeature, enabled: boolean) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/enabled_features/{feature}`, {
    path: {feature},
    body: enabled,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updatePromptModifiers(preferences: PromptModifiers) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/prompt_modifiers`, {
    path: {},
    body: preferences,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateAiModelConfig(config: AiModelConfig) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/ai_model_config`, {
    path: {},
    body: config,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateProcessStepPropertyConfig(config: ProcessStepPropertyConfig) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/tprm/process_step_property_config`, {
    path: {},
    body: config,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateTprmPreferences(preferences: TprmAccountPreferences) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/tprm/account_preferences`, {
    path: {},
    body: preferences,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}

export async function updateDefaultQaMode(qaMode: QAMode) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/config/default_qa_mode`, {
    path: {},
    body: qaMode,
  });
  await invalidateQueries([q.whoAmIOnAccount.filter(), q.accounts.filter()]);
  return res;
}
